import React, { FC } from 'react';
import { Box, Typography, Container, Stack } from '@mui/material';
import { styled } from '@mui/system';
import { alpha } from '@mui/system';

interface HeroHeaderSectionProps {
	title: string;
	description: string;
	backgroundImage: string;
}

const SectionBox = styled(Box)(() => ({
	position: 'relative',
	width: '100%',
	height: '700px',
	backgroundSize: 'cover',
	backgroundPosition: 'center',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	textAlign: 'center',
}));

const Overlay = styled(Box)({
	position: 'absolute',
	top: 0,
	left: 0,
	width: '100%',
	height: '100%',
	// background: "rgba(0, 0, 0, 0.5)", // Optional for overlay effect
});

const Content = styled(Box)({
	position: 'relative',
	zIndex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	paddingBottom: '5rem',
	height: '100%',
});

const HeroHeaderSection: FC<HeroHeaderSectionProps> = ({ title, description, backgroundImage }) => {
	return (
		<SectionBox component="section" sx={{ backgroundImage: `url("${backgroundImage}")` }}>
			<Overlay />
			<Content>
				<Container>
					<Stack
						direction={'row'}
						spacing={2}
						alignItems={'center'}
						justifyContent={'flex-start'}
						sx={{
							backgroundColor: (theme) => alpha(theme.palette.common.black, 0.75),
							padding: '8px 32px 8px 16px',
							width: 'fit-content',
						}}
					>
						<Typography variant="h1">{title}</Typography>
					</Stack>
					<Box
						sx={{
							backgroundColor: (theme) => alpha(theme.palette.common.black, 0.75),
							padding: '8px 32px 8px 16px',
							width: 'fit-content',
							marginTop: '1rem',
							textAlign: 'left',
						}}
					>
						<Typography variant="h6">{description}</Typography>
					</Box>
				</Container>
			</Content>
		</SectionBox>
	);
};

export default HeroHeaderSection;
